exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-ca8018c0] {\n    height: 19px;\n    margin-top: 35px;\n    margin-bottom: 30px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 19px;\n    display: flex;\n    align-items: center;\n}\ndiv[data-v-ca8018c0] {\n    width: calc(100% - 2px);\n}\n", ""]);

// exports
